export default __webpack_public_path__ + "static/media/host.e86249a3.svg";